// PhonicsReview.js
// 复习页组件：只渲染 storySections + 导航，不含 song/chant/thanks
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import StarIcon from '@mui/icons-material/Star';
import PhonicsStory from './PhonicsStory';
import RewardEffect from './RewardEffect';
import { usePhonicsNavigation } from './usePhonicsNavigation';

function PhonicsReview({ data }) {
  const STEPS = (data.storySections || []).map((section, i) => ({
    key: `story${i}`,
    label: section.label || `Step ${i + 1}`,
    renderFn: () => (
      <PhonicsStory
        data={section}
        mediaBase={data.mediaBase}
        layout={section.layout}
      />
    ),
  }));

  const { currentStep, setCurrentStep, isFullscreen, goNext, goPrev, toggleFullscreen, isFirst, isLast } = usePhonicsNavigation(STEPS);
  const [rewardTrigger, setRewardTrigger] = useState(0);

  if (STEPS.length === 0) return null;

  return (
    <div className="phonics-root">
      {/* 奖励效果 */}
      <RewardEffect
        key={rewardTrigger}
        trigger={rewardTrigger > 0}
        onDone={() => setRewardTrigger(0)}
      />

      <div className="phonics-content">
        {STEPS[currentStep].renderFn()}
      </div>
      <div className="phonics-footer">
        <Tooltip title="上一步">
          <IconButton
            size="small"
            onClick={goPrev}
            disabled={isFirst}
            className="phonics-nav-btn"
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>

        <div className="phonics-progress">
          {STEPS.map((step, idx) => (
            <React.Fragment key={step.key}>
              <div
                className={'phonics-progress-dot' + (idx === currentStep ? ' active' : '')}
                title={step.label}
                onClick={() => setCurrentStep(idx)}
                style={{ cursor: 'pointer' }}
              />
              {idx < STEPS.length - 1 && (
                <div className="phonics-progress-line" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Tooltip title="太棒了！">
            <IconButton size="small" onClick={() => setRewardTrigger(t => t + 1)} className="phonics-nav-btn" sx={{ color: '#FFD700' }}>
              <StarIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
            <IconButton size="small" onClick={toggleFullscreen} className="phonics-nav-btn">
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
          </Tooltip>
          <Tooltip title="下一步">
            <IconButton
              size="small"
              onClick={goNext}
              disabled={isLast}
              className="phonics-nav-btn"
            >
              <ArrowForwardIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default PhonicsReview;
